<template>
  <div class="gest_risorse">
    <main>
      <slot name="bottoni"> </slot>
      <div id="tabella">
        <table id="diagram_table">
          <thead>
            <tr />
            <tr />
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </main>
    <v-progress-linear
      indeterminate
      color="cyan"
      v-if="caricamento_dati"
      id="progress"
    >
    </v-progress-linear>
  </div>
</template>

<script>
import CalendarG from "@/components/GANTT_NEW/Classes/CalendarG.js";
import Connect from "@/components/GANTT_NEW/Classes/Connect.js";
export default {
  name: "DiagramG",
  components: {},
  props: ["transferData"],
  data() {
    return {
      caricamento_dati: false,
      CALENDAR: new CalendarG(),
      CONNECT: new Connect(),
      selected: 3,
      attivita: new Array(),
      tasks: new Array(),
      risorse: new Array(),
    };
  },
  async mounted() {
    await this.getJsonDalServer();
    //this.CALENDAR.gestore_db(this.attivita, this.tasks, this.risorse);
    this.$nextTick(() => {
      this.CALENDAR.build(this.attivita, this.tasks, this.risorse);
    });
    this.CONNECT.setListener();
  },
  methods: {
    async getJsonDalServer() {
      let that = this;
      // let tasks = new Array();
      let db_exist = true;
      try {
        await new Promise((resolve) => {
          var request = indexedDB.open("commessa_db", this.CALENDAR.version_db);
          request.onerror = function () {
            db_exist = false;
            resolve();
          };
          request.onsuccess = function (event) {
            that.CALENDAR.db_connection = event.target.result;
            resolve();
          };
          request.onupgradeneeded = function (event) {
            event.target.transaction.abort();
            db_exist = false;
            resolve();
          };
        });
      } catch {
        console.log("Database non presente, caricamento dati dal server.");
      }

      console.log(db_exist);
      if (!db_exist) {
        this.caricamento_dati = true;
        var request = {
          controller: "Schedulatore",
          method: "POST",
          richiesta: {
            action: "lista",
            token: localStorage.getItem("user_token"),
            data_inizio: "2022-01-21T08:00:00",
          },
        };

        return this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status == 200) {
              this.caricamento_dati = false;
              this.attivita = res.data.attivita;
              this.tasks = res.data.jobs;
              this.risorse = res.data.risorse;
              console.log(this.attivita);
              this.CALENDAR.gestore_db(this.attivita, this.tasks, this.risorse);
            }

            return true;
          })
          .catch((err) => {
            console.log("ERRORE");
            if (
              err.response == undefined ||
              err.response.status == 401 ||
              err.response.status == 403 ||
              err.status == 401 ||
              err.status == 403
            ) {
              localStorage.clear();
            }
            console.log(err);
            return false;
          });
      }
    },

    switchView(zoom) {
      this.CALENDAR.setZoom(zoom);
      this.CALENDAR.build(this.attivita, this.tasks, this.risorse);
      console.log("Connect: ", this.CONNECT);
    },

    deleteDB() {
      var DBDeleteRequest = window.indexedDB.deleteDatabase("commessa_db");
      DBDeleteRequest.onerror = function () {
        console.log("Error deleting database.");
      };

      DBDeleteRequest.onsuccess = function () {
        console.log("Database deleted successfully");
      };
    },
  },
};
</script>

<style scoped>
.gest_risorse {
  --accent: #506ad4;
  --background: white;
  position: relative;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  text-align: middle;
  background-color: white;
  z-index: 1;
  user-select: none;
}

.gest_risorse > main {
  position: relative;
  width: 100%;
}

.gest_risorse > main > section {
  height: calc(70px / var(--zoomlevel));
  width: 100%;
  position: relative;
  color: var(--accent);
  white-space: nowrap;
  padding: calc(10px / var(--zoomlevel));
  background-color: lightgrey;
}

.gest_risorse table {
  text-align: left;
  border-collapse: collapse;
  --cellheight: 40px;
  font-size: 14px;
}

#tabella {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: scroll;
}

#diagram_table {
  --unit: 100px;
  position: relative;
  height: 100%;
  background-color: rgb(255, 255, 255);
  border-collapse: collapse;
}

#diagram_table > thead > tr > th {
  text-align: center;
  padding: 3px;
  white-space: nowrap;
  border: 1px solid #a3cdd9;
}

#diagram_table > thead > tr:nth-of-type(2) > th:not(.col_attivita) {
  min-width: 60px !important;
  max-width: 60px !important;
  min-height: 30px !important;
  max-height: 30px !important;
}

.gest_risorse table tr {
  min-height: 30px !important;
  max-height: 30px !important;
  position: relative;
}

.gest_risorse table td:not([data-itemtype="1"]) {
  height: 40px;
  margin-left: 250px;
  border-collapse: collapse;
  border: 1px solid #a3cdd9;
  white-space: nowrap;
  position: relative;
}

td > figure > div > aside {
  position: absolute;
  top: 50%;
  height: 12px;
  width: 12px;
  background-color: white;
  left: -6px;
  border-radius: 100%;
  border: 1px solid black;
  box-sizing: border-box;
  /*display: none;*/
}

td > figure > div > aside:nth-of-type(2) {
  left: calc(100% - 6px);
}

#diagram_table td:not([data-itemtype]) {
  color: transparent;
}

#diagram_table td[data-itemtype] {
  overflow: visible;
  padding: 0;
  box-sizing: border-box;
}

/*Correzione della larghezza per tenere in considerazione anche il bordo delle celle*/
#diagram_table td figure {
  position: absolute;
  top: 2.5%;
  left: 0;
  height: 95%;
  --zoomlevel: 3;
  --temp: calc(1px * var(--zoomlevel));
  width: calc((100% * var(--duration)) + ((var(--temp) * (var(--duration)))));
  display: block;
}

#diagram_table td:not([data-itemtype="2"]) > figure > div {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgb(80, 106, 212, 0.3);
  border-radius: 3px;
  border: 1px solid #172736;
}

#diagram_table td > figure > div > span {
  position: relative;
  top: 0;
  left: 0;
  margin: 0;
  padding: 4px 0;
  height: 80%;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  display: block;
  text-indent: 3px;
}

#td_risorsa {
  border: 1px solid rgba(12, 182, 54, 0.5);
  border-radius: 5px;
  height: 100%;
  text-align: center;
  padding: 0 4px;
  background-color: rgba(23, 114, 46, 0.1);
}

#completamento {
  width: calc(1% * (var(--completamento))) !important;
  height: 10% !important;
  top: 50%;
  background-color: rgba(12, 182, 54, 0.5);
}

#diagram_table td[data-itemtype="0"] {
  position: relative;
  height: 100%;

  /*display: block;*/
}

.col_attivita {
  padding-left: 7px !important;
  padding-right: 7px !important;
  position: sticky;
  text-align: center;
  left: 0px;
  background-color: white;
  min-width: 220px !important;
  max-width: 220px !important;
  z-index: 2;
  border: 1px solid #a3cdd9;
}

#diagram_table td[data-itemtype="2"] > figure > div {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(223, 110, 110, 0.589);
  border-radius: 3px;
  border: 1px solid #172736;
}
#diagram_table td[data-itemtype="2"] {
  position: relative;
  height: 100%;
  --zoomlevel: 1;
  --temp: calc(1px / var(--zoomlevel));
  width: calc(
    (100% * var(--duration_vinc)) +
      ((var(--temp) * (var(--duration_vinc))) - var(--temp))
  );
  display: block;
}

/*.col_risorsa {
  min-width: 70px ;
  min-height: 25px;
  position: fixed !important;
  background: #a3cdd9;
}
*/

.context-menu {
  position: absolute;
  display: none;
  color: black;
  z-index: 20;
}

.context-menu--active {
  display: block !important;
  padding: 6px;
}

.context-menu-vinc- {
  position: absolute;
  display: none;
  color: black;
}

.context-menu-vinc--active {
  display: block !important;
  padding: 6px;
}

svg {
  position: absolute;
  pointer-events: none;
  width: 100%;
  padding:0;
  margin:0;
  height: 80vh;
  top: -120px;
  left: 0;
  z-index: 0;
}
</style>